import styled, { keyframes } from 'styled-components';

export const StoreHeaderContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
`;

export const Banner = styled.div`
  width: 100%;
  height: var(--banner-height, 250px);
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, oklch(0 0 0 / 0) 60%, oklch(0 0 0 / 0.8) 100%);
    pointer-events: none;
    z-index: 1;
  }

  @media (max-width: 768px) {
    height: 200px;
  }
`;

export const BannerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CartHeaderContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 30;

  @media (max-width: 768px) {
    left: 15px;
    top: 15px;
  }
`;

export const CartBtnHeader = styled.button`
  background: oklch(1 0 0 / 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 12px oklch(0 0 0 / 0.1);
  transition: transform 0.2s;
`;

export const CartIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CartIconImg = styled.img`
  width: 22px;
  height: 22px;
`;

export const CartCountBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: var(--primary-color, oklch(0.65 0.24 33.09));
  color: oklch(1 0 0);
  font-size: 11px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 2px solid oklch(1 0 0);
  box-sizing: content-box;
`;

interface DeliverySettingsProps {
  $active: 'all' | 'offers';
}

export const DeliverySettings = styled.div<DeliverySettingsProps>`
  width: 130px;
  height: 44px;
  background-color: oklch(0.9842 0.0034 247.86 / 0.81);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 999px;
  position: absolute;
  left: 20px;
  /* Top = Banner Height (250) - Half Toggle Height (22) = 228px */
  top: 228px; 
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  padding: 5px;
  z-index: 20;

  @media (max-width: 768px) {
    left: 15px;
    top: 180px; 
  }

  &::before {
    content: '';
    position: absolute;
    top: 5px;
    bottom: 5px;
    width: calc((100% - 15px) / 2); 
    border-radius: 999px;
    background-color: var(--primary-color, oklch(0.65 0.24 33.09));
    box-shadow: 0 4px 10px oklch(0.65 0.24 33.09 / 0.4);
    transition: transform 0.5s cubic-bezier(0.45, -0.32, 0.13, 1.32);
    z-index: 1;
    
    right: 5px;
    transform: ${props => props.$active === 'all' ? 'translateX(0)' : 'translateX(calc(-100% - 5px))'};
  }
`;

export const ToggleButton = styled.button<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.$isActive ? 'var(--btn-text-active, oklch(1 0 0))' : 'var(--btn-text-inactive, oklch(0.3211 0 0))'};
  font-size: 14px;
  background-color: transparent;
  position: relative;
  z-index: 9;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  transition: color 0.5s;
`;

export const LogoContainer = styled.div<{ $logoUrl?: string }>`
  position: absolute;
  top: 205px;
  right: 20px;
  width: 90px;
  height: 90px;
  background: oklch(1 0 0); 
  border-radius: 50%;
  padding: 5px; 
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0; /* Offset for shadow effect */
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 90%;
    height: 90%;
    background-image: url(${props => props.$logoUrl});
    background-size: cover;
    background-position: center;
    filter: blur(18px); /* Blur to create shadow look */
    z-index: -1;
    border-radius: 50%;
    opacity: 0.7;
    transition: all 0.3s ease;
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    top: 165px;
    right: 15px;
    padding: 0;
  }
`;

export const StoreLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid oklch(0.9288 0.0126 255.51);
`;

// ==================== Busy Badge (المتجر مشغول) ====================

/* وميض أحمر نابض حول الشارة العائمة فوق الأفتار */
const busyBadgePulse = keyframes`
  0% {
    box-shadow: 0 2px 6px oklch(0.61 0.25 28.5 / 0.45), 0 0 0 0 oklch(0.61 0.25 28.5 / 0.55);
  }
  70% {
    box-shadow: 0 2px 6px oklch(0.61 0.25 28.5 / 0.45), 0 0 0 9px oklch(0.61 0.25 28.5 / 0);
  }
  100% {
    box-shadow: 0 2px 6px oklch(0.61 0.25 28.5 / 0.45), 0 0 0 0 oklch(0.61 0.25 28.5 / 0);
  }
`;

export const BusyBadge = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: oklch(0.61 0.25 28.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: oklch(1 0 0);
  z-index: 2;
  animation: ${busyBadgePulse} 1.8s ease-out infinite;

  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
    bottom: 2px;
    left: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    box-shadow: 0 2px 6px oklch(0.61 0.25 28.5 / 0.45);
  }
`;

// ==================== Skeleton Styles ====================

const shimmer = `
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonLogo = styled.div`
  ${shimmer}
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    oklch(0.9683 0.0069 247.9) 0%,
    oklch(0.9288 0.0126 255.51) 20%,
    oklch(0.9683 0.0069 247.9) 40%,
    oklch(0.9683 0.0069 247.9) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
`;

export const LogoPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: oklch(0.9842 0.0034 247.86);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SkeletonBanner = styled.div`
  ${shimmer}
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    oklch(0.9683 0.0069 247.9) 0%,
    oklch(0.9288 0.0126 255.51) 20%,
    oklch(0.9683 0.0069 247.9) 40%,
    oklch(0.9683 0.0069 247.9) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
`;

export const BannerPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background-color: oklch(0.9842 0.0034 247.86);
  display: flex;
  align-items: center;
  justify-content: center;
`;
